<div class="text-center mx-7">
  <div style="height: 60vh" class="flex justify-content-center align-items-end">
    <img src="assets/FP-construction.png" alt="Logo" />
  </div>
  <h1 class="mt-4 block">Sorry, we’re down for scheduled maintenance right now.</h1>
  <p>Hang on tight, you’ll be redirected back soon!</p>
</div>
